import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type ApplicationItem, RequestStrategyEnum } from '@shared/api';

interface UseApplicationsByCustomerStore {
  loading: boolean;
  data: ApplicationItem[];
  error: string | null;
  getApplicationsByCustomer: (customerId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationsByCustomerStore = create<UseApplicationsByCustomerStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getApplicationsByCustomer: ApiUtils.wrapperApi(async (customerId, signal) => {
    try {
      set({ loading: true, data: [], error: null });
      const result = await ApplicationApi.getApplicationsByCustomer(customerId, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
